import styled from 'styled-components';

export const SpinnerWrapper = styled.div`
    width: 100%;
    padding-top: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
`;import styled from 'styled-components';

export const SpinnerWrapper = styled.div`
    width: 100%;
    padding-top: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
`;